import type { ReactNode } from "react";
import SiteNavbar from "@/components/site/SiteNavbar";
import SiteFooter from "@/components/site/SiteFooter";
import { LazyCookieConsent } from "@/components/LazyCookieConsent";

export default function SiteShell({ children }: { children: ReactNode }) {
  return (
    <div className="site-a min-h-screen antialiased">
      <SiteNavbar />
      <main className="pt-16">{children}</main>
      <SiteFooter />
      <LazyCookieConsent />
    </div>
  );
}
